import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

function useRouteLeaveGuard(allowCondition) {
  const history = useHistory()
  const [prompt, setPrompt] = useState(false)
  const [allowed, setAllowed] = useState(false)

  const destination = useRef(null)
  const action = useRef(null)
  const unblock = useRef(null)

  const handleBlock = (requestedLocation, requestedAction) => {
    if (!allowed && !allowCondition) {
      action.current = requestedAction
      destination.current = requestedLocation
      setPrompt(true)
      return false
    }
    setAllowed(false)
    return true
  }

  if (unblock.current) {
    unblock.current()
  }

  unblock.current = history.block(handleBlock)

  useEffect(() => {
    if (allowed) {
      if (action.current === 'PUSH') {
        history.push(destination.current.pathname)
        return
      }

      history.replace(destination.current)
    }
  }, [allowed])

  useEffect(
    () => () => {
      unblock.current()
    },
    []
  )

  const { current: deny } = useRef(() => {
    setPrompt(false)
  })

  const { current: allow } = useRef(() => {
    setPrompt(false)
    setAllowed(true)
  })

  return [prompt, allow, deny]
}

export default useRouteLeaveGuard
